module.exports = __webpack_public_path__ + "static/media/banner2.e356a7ee.jpg";